import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Landing from "@/pages/Landing";

// Code splitting: estas rutas se cargan bajo demanda (mejora el tiempo de carga inicial)
const Calculator = lazy(() => import("@/pages/Calculator"));
const Privacy = lazy(() => import("@/pages/Privacy"));
const LegalNotice = lazy(() => import("@/pages/LegalNotice"));
const AdminDashboard = lazy(() => import("@/pages/Admin"));
const AdminLogin = lazy(() => import("@/pages/Admin").then((m) => ({ default: m.AdminLogin })));

function App() {
  return (
    <div className="App">
      <SmoothScroll>
        <BrowserRouter>
          <Suspense fallback={<div className="min-h-screen bg-[#06231D]" />}>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/privacidad" element={<Privacy />} />
              <Route path="/aviso-legal" element={<LegalNotice />} />
              <Route path="/calculadora" element={<Calculator />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </Suspense>
          <Toaster position="bottom-right" theme="dark" />
        </BrowserRouter>
      </SmoothScroll>
    </div>
  );
}

export default App;
